var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#DADADA",
  stroke: "#DADADA",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "$",
  d: "M14 .811 13.188 0 7 6.189.812 0 0 .811l6.188 6.19L0 13.188.812 14 7 7.812 13.188 14l.812-.811L7.811 7z"
}))));
export default SvgClose;